import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where,
  type DocumentData,
} from 'firebase/firestore';
import { deleteObject, getDownloadURL, ref } from 'firebase/storage';
import { firebase } from './firebase';
import type { Snippet } from '@snippits/shared';

export async function getSnippet(id: string): Promise<Snippet | null> {
  const snap = await getDoc(doc(firebase.db, 'snippets', id));
  return snap.exists() ? (snap.data() as Snippet) : null;
}

export async function getSnippetImageUrl(snippet: Snippet): Promise<string> {
  return getDownloadURL(ref(firebase.storage, snippet.storagePath));
}

export async function listMySnippets(ownerUid: string): Promise<Snippet[]> {
  const q = query(
    collection(firebase.db, 'snippets'),
    where('ownerUid', '==', ownerUid),
    orderBy('createdAt', 'desc'),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => d.data() as DocumentData as Snippet);
}

export async function deleteSnippet(snippet: Snippet) {
  await deleteDoc(doc(firebase.db, 'snippets', snippet.id));
  await deleteObject(ref(firebase.storage, snippet.storagePath));
}

export async function updateSnippetTitle(id: string, title: string) {
  await updateDoc(doc(firebase.db, 'snippets', id), { title: title.trim() || 'Untitled' });
}
